module.exports = __webpack_public_path__ + "img/7.4208b678.jpg";